import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lock-bidding-wrapper" }
const _hoisted_2 = { class: "title" }

import LockedBiddingBtn from "@/components/_partials/LockedBiddingBtn.vue";
  import { trans } from "@/utils/trans";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { computed } from "vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LockBidding',
  emits: ["changeTab"],
  setup(__props, { emit: __emit }) {

  const auctionStore = useAuctionStore();

  const emit = __emit;

  const openFirstTab = () => {
    const tab = auctionStore.user?.is_admin ? "users" : "history";
    emit("changeTab", tab);
  };

  const titleFirst = computed(() => {
    if (!auctionStore.user?.is_admin) {
      return trans("live.tabs.lock_unlock.buyer_title_1");
    } else {
      return trans("live.tabs.lock_unlock.title_1");
    }
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(titleFirst.value) + " ", 1),
      _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" " + _toDisplayString(_unref(trans)("live.tabs.lock_unlock.title_2")), 1)
    ]),
    _createVNode(LockedBiddingBtn),
    _createElementVNode("a", {
      class: "btn btn-blue-outline btn-return",
      onClick: openFirstTab
    }, _toDisplayString(_unref(trans)("live.tabs.lock_unlock.return_btn_label")), 1)
  ]))
}
}

})